import React, { useState, useEffect } from 'react'
import SelectItems from '../../../select-items/SelectItems';
import axios from 'axios';
import ApiUrl from '../../../../services/ApiUrl';
import { useSelector } from 'react-redux';
import EditorComponent from './../../../editor/Editor';
import Input from './../../../input/Input';

let validateNumber = 0;
const BrandsList = ( props ) => {
    let [ load, setLoad ] = useState(false);
    let [ error, setErrors ] = useState(false);
    let [ pages, setPages ] = useState(false);
    let [ forceValidate, setForceValidate ] = useState(false);
    let lang = props.langID

    useEffect(() => {
        if(!load && !props.edit) {
            props.onChange({
                header: '',
                text: '',
                // items: [],
            }, props.index);
            // getPages();
            setLoad(true);
        }
        if(!load) {
            validateNumber = props.validate;
        }
    }, [load])

    useEffect(() => {
        if(!load && props.edit) {
            if(!props.data || Object.keys(props.data).length == 0) {
                props.onChange({
                    header: '',
                    text: '',
                    // items: [],
                }, props.index);
            }
            // getPages();
            setLoad(true);
        }
    }, [load])

    useEffect(() => {
        if(props.validate !== validateNumber) {
            validate();
        }
    }, [props.validate])

    const validate = async() => {
        await setForceValidate(true);
        await wait(100);
        await setForceValidate(false);
        let errors = await checkErrors();
        if(errors) {
            setErrors(true);
        }else{
            setErrors(false);
        }
    }

    const updateValue = (val, label) => {
        let newData = props.data;
        newData[label] = val;
        props.onChange({
            newData
        })
    }

    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    let checkErrors = () => {
        let result;
        let elements = document.querySelectorAll(`.marketing-support-${props.index} .error`);
        if( elements.length > 0 ) {
            result = true;
        } else {
            result = false;
        }
        return result;
    }

    const getPages = () => {
        axios({
            method: 'get',
            url: `${ApiUrl()}/pagesList?langID=${lang}&postType=marketing-support`,
            headers: { Authorization: `Bearer ${ localStorage.getItem('token') }` }
        }).then(response => {
            let res = JSON.parse(response.request.response);
            console.log(res)
            setPages(res.data);
        })
    }

    return (
        <div className={error ? `section-wrapper marketing-support error-section marketing-support-${props.index}` : `section-wrapper marketing-support marketing-support-${props.index}`}>
            {/* <div className="row-section">
                {pages && pages.length > 0 &&
                    <div className="select-boxes">
                        <SelectItems
                            label="Marketing support"
                            data={ pages } 
                            value={ props.data.items }
                            handle={ (val) => updateValue(val, 'items') } 
                            forceValidate={ forceValidate } 
                            column="xs-12" />
                    </div>
                }
            </div> */}
            <div className="row-section">
                <EditorComponent required={true} forceValidate={ forceValidate } setFunction={ val => updateValue(val, 'text') } value={props.data.text} label="Tekst" />
            </div>
            <div className="row-section">
                <Input  required={ false }
                    setFunction={ val => updateValue(val, 'header') }
                    value={props.data.header}
                    label={ 'Nagłówek' }
                    regExp={ /.*/ }
                    minChar={ 3 } 
                    forceValidate={ forceValidate } 
                />
            </div>
        </div>
    );
}

export default BrandsList;